import Login from "@/views/Login";
import Trip from "@/views/Trip";
import Place from "@/views/Place";
import Expense from "@/views/Expense";
import AddNewPlace from "@/components/forms/NewPlace";
import NewTrip from "@/components/forms/NewTrip";
import NewExpense from "@/components/forms/NewExpense";
import HowTo from "@/views/HowTo";
import Settings from "@/views/Settings";
import { store } from "@/store";
import Stats from "@/views/Stats";
import NewPlace from "@/components/forms/NewPlace";
import NewCar from "@/components/forms/NewCar";

export const routes = [
  { path: "/", component: NewTrip, name: "home" },
  {
    path: "/login",
    component: Login,
    name: "login",
    beforeEnter: (to, from, next) => {
      if (store.state.isAuth) {
        next({ name: "new-trip" });
      }
      next();
    }
  },
  { path: "/trips", component: Trip, name: "trips" },
  { path: "/add-trip", component: NewTrip, name: "new-trip" },
  {
    path: "/edit-trip",
    component: NewTrip,
    name: "edit-trip",
    props: true,
    beforeEnter: (to, from, next) => {
      from.name === "trips" || from.name === "new-trip"
        ? next()
        : next({ name: "trips" });
    }
  },
  { path: "/places", component: Place, props: true, name: "places" },
  {
    path: "/add-place",
    component: AddNewPlace,
    props: true,
    name: "new-place"
  },
  {
    path: "/edit-place",
    component: NewPlace,
    name: "edit-place",
    props: true,
    beforeEnter: (to, from, next) => {
      from.name === "places" || from.name === "new-place"
        ? next()
        : next({ name: "places" });
    }
  },
  {
    path: "/add-expense",
    component: NewExpense,
    name: "new-expense",
    props: true
  },
  {
    path: "/edit-expense",
    component: NewExpense,
    name: "edit-expense",
    props: true,
    beforeEnter: (to, from, next) => {
      from.name === "expenses" || from.name === "new-expense"
        ? next()
        : next({ name: "expenses" });
    }
  },
  { path: "/add-cars", component: NewCar, name: "new-car", props: true },
  // { path: "/cars", component: NewCar, name: 'new-car', props: true},
  { path: "/expense", component: Expense, name: "expenses" },
  { path: "/stats", component: Stats, name: "stats" },
  { path: "/how-it-works", component: HowTo, name: "how-it-works" },
  { path: "/settings", component: Settings, name: "settings", props: true }
];
